import StartAudioContext from 'startaudiocontext';
import bowser from 'bowser';
import Audio from "../../teach/lib/audio";
import Cartoon from "../../teach/guide/avatar-action";
import xiaoao from "../../teach/components/xiaoAo";
let AUDIO_CONTEXT;

if (!bowser.msie) {
    /**
     * AudioContext can be initialized only when user interaction event happens
     */
    const event =
        typeof document.ontouchstart === 'undefined' ?
            'mousedown' :
            'touchstart';
    const initAudioContext = () => {
        document.removeEventListener(event, initAudioContext);
        AUDIO_CONTEXT = new (window.AudioContext ||
            window.webkitAudioContext)();
        StartAudioContext(AUDIO_CONTEXT);
        // Audio.tts('你好，' + (window.store.getState().teach.user.name || '') + '，欢迎回来，' + window.config.slogan[Math.floor(Math.random() * window.config.slogan.length)]);

        Cartoon.onlySpeak();
        Cartoon.muteHide();
        
        // window.speak('你好，' + (window.store.getState().teach.user.name || '') + '，欢迎回来，' + window.config.slogan[Math.floor(Math.random() * window.config.slogan.length)],null,0)
    };
    document.addEventListener(event, initAudioContext);

    document.addEventListener('onload',window.cartoon())
}

/**
 * Wrap browser AudioContext because we shouldn't create more than one
 * @return {AudioContext} The singleton AudioContext
 */
export default function () {
    return AUDIO_CONTEXT;
}
